module.exports = __webpack_public_path__ + "videos/selection-overlay.ca5030c.mp4";